export enum ORDER_STATUS {
  PENDING = 0,
  PARTIALLY_PAID = 1,
  PAID = 2,
  CANCELLED = 3
};
